import { register } from "./registry";

let hotkeysBound = false;
let submitting = false;

register((root) => {
  if (hotkeysBound) return;
  hotkeysBound = true;

  document.body.addEventListener("htmx:afterOnLoad", () => { submitting = false; });
  document.body.addEventListener("kit:saved", () => { submitting = false; });

  document.addEventListener("keydown", (e) => {
    const ev = e as KeyboardEvent;
    if (ev.ctrlKey && (ev.key === "s" || ev.key === "S") || ev.key === "F10") {
      ev.preventDefault();
      if (submitting) return;
      submitting = true;
      setTimeout(() => { submitting = false; }, 200);
      const openDialog = document.querySelector<HTMLDialogElement>("dialog[open]");
      const form = (openDialog?.querySelector("form") ?? (document.activeElement as HTMLElement)?.closest("form") ?? document.querySelector("[data-kit-form]")) as HTMLFormElement | null;
      if (form) {
        // Clean up empty grid rows before collecting values
        form.querySelectorAll<HTMLTableElement>("table[data-kit-grid]").forEach((grid) => {
          const body = grid.tBodies[0];
          if (body) {
            const cells = (tr: HTMLTableRowElement) => Array.from(tr.querySelectorAll<HTMLInputElement | HTMLSelectElement>("[data-kit-col]")).filter(c => !c.disabled && (!(c instanceof HTMLInputElement) || !c.readOnly));
            const isEmpty = (tr: HTMLTableRowElement) => {
              const biltiNo = tr.querySelector<HTMLInputElement>("[data-kit-col='biltiNo']");
              const series = tr.querySelector<HTMLInputElement>("[data-kit-col='series']");
              if (biltiNo || series) return (biltiNo?.value.trim() ?? "") === "" && (series?.value.trim() ?? "") === "";
              return !cells(tr).some((field) => {
                if (field.dataset.kitCol === "tax") return false;
                if (field instanceof HTMLInputElement && (field.type === "checkbox" || field.type === "radio")) return field.checked;
                return field.value.trim() !== "";
              });
            };
            Array.from(body.rows).forEach((row) => {
              if (isEmpty(row) && body.rows.length > 1) row.remove();
            });
            Array.from(body.rows).forEach((row, idx) => {
              row.querySelectorAll<HTMLInputElement>("[name]").forEach((input) => {
                input.name = input.name.replace(/\[(#|\d+)\]/, `[${idx}]`);
              });
            });
          }
        });
        // The Save button first; never a submit button that belongs to another form (e.g. a row's Remove button).
        const saveBtn = form.querySelector<HTMLButtonElement>("[data-kit-save]")
          ?? Array.from(form.querySelectorAll<HTMLButtonElement>("button[type='submit']")).find((b) => b.form === form) ?? null;
        if (saveBtn && !saveBtn.disabled) {
          saveBtn.click();
        } else if (!saveBtn?.disabled) {
          try { form.requestSubmit(); } catch {}
        }
      }
      return;
    }

    if (ev.ctrlKey && (ev.key === "d" || ev.key === "D")) {
      const draftBtn = document.querySelector<HTMLButtonElement>("button[data-kit-draft]");
      if (draftBtn) {
        ev.preventDefault();
        draftBtn.click();
      }
      return;
    }

    if (ev.altKey && (ev.key === "n" || ev.key === "N")) {
      ev.preventDefault();
      const el = document.querySelector("[data-kit-new]");
      if (el) {
        const href = el.getAttribute("data-kit-new") || (el as HTMLAnchorElement).href;
        if (href) window.location.href = href;
      }
      return;
    }

    if (ev.altKey && (ev.key === "l" || ev.key === "L")) {
      ev.preventDefault();
      const el = document.querySelector("[data-kit-list]");
      if (el) {
        const href = el.getAttribute("data-kit-list") || (el as HTMLAnchorElement).href;
        if (href) window.location.href = href;
      }
      return;
    }

    if (ev.ctrlKey && (ev.key === "p" || ev.key === "P")) {
      const el = document.querySelector("[data-kit-print]");
      if (el) {
        ev.preventDefault();
        let url = el.getAttribute("data-kit-print") || "";
        const form = el instanceof HTMLFormElement ? el : el.closest("form");
        if (form) {
          const fd = new FormData(form);
          const q = new URLSearchParams();
          for (const [k, v] of fd.entries()) {
            if (typeof v === "string" && v && !k.startsWith("__") && !k.endsWith("Text")) {
              q.set(k, v);
            }
          }
          const base = url.split("?")[0] ?? "";
          url = q.size > 0 ? `${base}?${q.toString()}` : base;
        }
        if (url) {
          const targetUrl = new URL(url, window.location.origin).href;
          window.open(targetUrl, "_blank");
        }
      }
      return;
    }

    if (ev.key.startsWith("F") && ev.key.length <= 3) {
      const active = document.activeElement;
      if (active instanceof HTMLElement) {
        if (ev.key === "F5") ev.preventDefault();
        active.dispatchEvent(new CustomEvent("kit:fkey", { detail: { key: ev.key, field: active } }));
      }
    }
  });
});
